// Human-approved Katé Article v1.0. Do not edit editorial wording without review.
export const approvedKateArticleVi = String.raw`# Lễ Katé của người Chăm

Mỗi năm, khi Chăm lịch bước sang **1 bingun bilan 7**, cộng đồng Chăm lại bước
vào một trong những dịp lễ quan trọng trong năm: **Katé**, thường được viết là
**Katê** trong tiếng Việt.

Với nhiều người, Katé được biết đến qua hình ảnh dòng người lên tháp, tiếng
trống Ginăng, kèn Saranai, những điệu múa và sắc màu trang phục Chăm. Nhưng
phía sau phần hội dễ nhìn thấy ấy là một hệ thống lễ tục gắn với lịch Chăm,
tín ngưỡng, đền tháp, chức sắc, palei, gia đình và những mối quan hệ văn hóa
được gìn giữ qua nhiều thế hệ.

Katé còn cho thấy mối quan hệ lâu đời giữa người Chăm và người Raglai, đồng
thời có mối liên hệ với lễ **Ca-mbur** trong hệ thống lễ nghi Chăm.


## Katé diễn ra khi nào?

Ngày chính lễ Katé được xác định theo Chăm lịch vào:

**1 bingun bilan 7**

Trong đó, *bilan* là tháng, còn *bingun* chỉ nửa đầu của tháng theo cách gọi
truyền thống. Ngày tương ứng trên Dương lịch không cố định mà thay đổi theo
từng năm.

Đây cũng là cách Sakawi xác định ngày Katé: ngày lễ được tính từ **Chăm lịch**,
sau đó mới đối chiếu sang Dương lịch.

Vào ngày chính lễ, các nghi thức quan trọng được thực hiện tại những đền, tháp
gắn với các vị được cộng đồng phụng thờ. Ở Ninh Thuận, ba địa điểm thường được
nhắc đến trong Katé là **tháp Po Klaong Garai**, **tháp Po Rome** và
**đền Po Inâ Nâgar tại palei Hamu Tanran (làng Hữu Đức)**.

Tuy nhiên, tại Hamu Tanran, Katé đã bắt đầu **trước ngày chính lễ một ngày**,
gắn với nghi thức đón y trang Po Inâ Nâgar do người Raglai gìn giữ.

Vì vậy, trên lịch Sakawi có một sự kiện riêng:

**Katé palei Hamu Tanran**

Sự kiện này diễn ra trước **Katé chính lễ** một ngày.

Việc tách thành hai mốc không có nghĩa Hamu Tanran có một lễ Katé khác.
Nó phản ánh diễn tiến thực tế của lễ: tại Hamu Tanran, các hoạt động Katé
bắt đầu từ ngày đón y trang, trước khi bước sang ngày chính lễ tại các đền,
tháp.


## Katé và Ca-mbur

Để hiểu Katé đầy đủ hơn, không nên nhìn ngày lễ này một cách tách biệt.

Trong hệ thống lễ tục Chăm, Katé có mối liên hệ với **Ca-mbur** — tên lễ cũng
được ghi dưới các dạng Cabbur hoặc Cambur trong một số tài liệu.

Nếu Katé diễn ra vào:

**1 bingun bilan 7**

thì Ca-mbur diễn ra vào:

**1 klem bilan 9**

Theo cách tính ngày liên tục trong tháng, \`1 klem\` tương ứng với ngày 16;
*bingun* thuộc nửa đầu tháng, còn *klem* thuộc nửa sau tháng.

Trong cách lý giải về tính đối ứng của hai lễ tục, **Katé gắn với dương,
Yang Amâ (thần cha) và các nam thần; Ca-mbur gắn với âm, Yang Inâ
(thần mẹ) và các nữ thần**. Hai lễ thường được nhìn trong những cặp biểu tượng
Nam – Nữ, Cha – Mẹ, Dương – Âm.

Như vậy, Katé và Ca-mbur không đơn thuần là hai ngày lễ nằm ở hai tháng khác
nhau của Chăm lịch, mà có mối quan hệ trong một cấu trúc lễ nghi mang tính
đối ứng.

Tuy nhiên, nói Katé “chỉ thờ nam thần” cũng chưa đầy đủ. Trong thực hành Katé
còn có việc phụng tế các vị vua được thần hóa, các vị thần, tưởng nhớ tổ tiên
và những lớp tín ngưỡng được bồi đắp qua lịch sử.


## Ai làm lễ và ai tham dự Katé?

Katé gắn chặt với hệ thống tín ngưỡng của cộng đồng **Chăm Ahier**, thường
được gọi là Chăm Bàlamôn.

Các nghi thức tôn giáo tại đền, tháp được thực hiện dưới sự chủ trì của hệ
thống chức sắc Chăm Bàlamôn. Trong đó, **Po Adhia** giữ vai trò quan trọng
trong việc chủ trì nghi lễ cùng các chức sắc và những người đảm nhiệm từng
phần lễ theo phong tục.

Nhưng điều đó không có nghĩa Katé chỉ có người Chăm Bàlamôn tham dự.

Trong không gian Katé còn có người Chăm **Bini/Awal**, người **Raglai**,
người dân các palei và những cộng đồng khác đến tham dự.

Vì vậy, cần phân biệt giữa **chủ thể và người chủ trì nghi lễ** với
**những cộng đồng tham dự lễ**.

Riêng đối với người Raglai, vai trò của họ còn đặc biệt hơn việc đến tham dự,
bởi mối quan hệ Chăm–Raglai được thể hiện ngay trong một số nghi thức Katé.


## “Chăm là chị, Raglai là em”

Trong quan niệm được lưu truyền giữa hai cộng đồng có cách nói rằng:

**“Chăm là chị, Raglai là em.”**

Một số cách kể cụ thể hơn xem người Chăm là **chị cả**, còn người Raglai là
**em út**.

Mối quan hệ ấy cũng được dùng để giải thích một tập tục đặc biệt:
**người Raglai gìn giữ y trang của các vị được người Chăm phụng thờ**.

Trong xã hội theo mẫu hệ, người con gái út thường là người thừa kế tài sản của
gia đình và đồng thời có trách nhiệm gìn giữ việc thờ phụng tổ tiên. Theo cách
lý giải truyền thống này, người Raglai – người “em út” – được giao gìn giữ
y trang và những vật thiêng liên quan đến các vị thần, vua được phụng thờ.

Các tư liệu về Katé ghi nhận người Raglai từng gìn giữ y trang liên quan đến
**Po Klaong Garai, Po Rome và Po Inâ Nâgar**. Đến mùa lễ, y trang được đưa
xuống để thực hiện các nghi thức cùng cộng đồng Chăm.

Nhà nghiên cứu **Trương Văn Món (Sakaya)** khi trao đổi về Katé cũng đề cập
đến mối quan hệ Chăm–Raglai và việc người Raglai gìn giữ y trang.

Nhìn từ góc độ này, người Raglai không đơn thuần là khách đến dự Katé.
Họ là một phần của mối quan hệ văn hóa được lưu giữ trong chính cấu trúc của
nghi lễ.


## Po Inâ Nâgar: từ Aia Trang về vùng Panduranga

Câu chuyện về Po Inâ Nâgar giúp nhìn rõ hơn mối liên hệ giữa lịch sử, địa lý
và lễ Katé ngày nay.

Theo những tư liệu được ghi lại, trước đây người Chăm vùng Panduranga vẫn
hành hương về nơi thờ **Po Inâ Nâgar ở Aia Trang (Nha Trang)** để thực hiện
các lễ tục.

Khi phương tiện giao thông còn khó khăn, việc từ vùng Phan Rang đi Aia Trang
để hành lễ là một hành trình dài. Những biến động lịch sử và chiến tranh về
sau càng khiến việc hành lễ tại nơi thờ cũ trở nên khó khăn.

Theo một số tư liệu, cộng đồng sau đó đã xin **thỉnh Po Inâ Nâgar về vùng
Panduranga** để thuận tiện cho việc cúng tế và thờ phụng.

Một số ghi chép cho biết nơi thờ từng được đặt tại khu vực
**Hamu Ram (Mông Nhuận)**, trước khi đền Po Inâ Nâgar được chuyển về cánh
đồng **Hamu Tanran** vào khoảng năm 1954, thuộc làng Hữu Đức ngày nay.

Ở đây, “thỉnh Po Inâ Nâgar về” nên được hiểu theo nghĩa chuyển nơi phụng thờ
trong truyền thống tín ngưỡng. Những nguồn hiện có chưa đủ cơ sở để khẳng định
rằng một pho tượng cụ thể tại Tháp Bà Nha Trang đã được mang về Hamu Tanran.

Ngày nay, đền Po Inâ Nâgar tại Hamu Tanran là một địa điểm quan trọng trong
hệ thống lễ tục của cộng đồng Chăm ở khu vực.


## Katé palei Hamu Tanran – ngày trước chính lễ

Điều đặc biệt tại Hamu Tanran là Katé bắt đầu trước ngày chính lễ.

Vào **ngày 30 bilan 6 Chăm lịch**, tức một ngày trước
**1 bingun bilan 7**, palei chuẩn bị đón y trang Po Inâ Nâgar do người Raglai
gìn giữ.

Tư liệu của Viện Âm nhạc Việt Nam mô tả rằng trước đây, từ buổi sáng,
Ban Phong tục Hữu Đức cử người lên làng Raglai xin rước y trang. Sau khi phía
Raglai thực hiện nghi thức theo phong tục, đoàn mang y trang xuống núi.
Khi đoàn về đến Hữu Đức, chức sắc và người dân Chăm ra đón và thực hiện nghi
thức giao nhận.

Những ghi nhận gần đây cho thấy lễ đón y trang vẫn được duy trì. Người Raglai
mang y trang Po Inâ Nâgar xuống Hamu Tanran trước ngày chính lễ; sáng hôm sau
y trang được rước lên đền để tiếp tục các nghi thức Katé.

Đây chính là ngày mà Sakawi ghi nhận thành sự kiện:

**Katé palei Hamu Tanran**

và đặt trước sự kiện **Katé** chính lễ một ngày.

Cách hiển thị này giúp người sử dụng lịch hiểu rằng Katé không chỉ là một mốc
ngày. Đối với Hamu Tanran, lễ đã bắt đầu từ ngày cộng đồng đón y trang
Po Inâ Nâgar.


## Một tập tục vẫn được gìn giữ, nhưng cũng đã thay đổi

Không phải mọi thực hành liên quan đến y trang hiện nay đều giống như trước.

Y trang của **Po Klaong Garai** và **Po Rome** đã được phía Raglai chuyển giao
cho người Chăm lưu giữ. Trong khi đó, nghi thức người Raglai đưa y trang
**Po Inâ Nâgar** về Hamu Tanran vào dịp Katé vẫn được duy trì.

Một số nguồn hiện đại ghi nhận y trang Po Inâ Nâgar được một dòng họ người
Raglai ở khu vực Phước Hà gìn giữ và đưa xuống Hữu Đức vào mùa Katé.

Bởi vậy, Hamu Tanran ngày nay là một trong những nơi có thể nhìn thấy khá rõ
mối quan hệ Chăm–Raglai được thể hiện bằng nghi lễ, chứ không chỉ còn tồn tại
trong những câu chuyện kể.


## Từ đền, tháp về palei và gia đình

Ngày chính lễ **1 bingun bilan 7**, các nghi thức Katé được thực hiện tại các
đền, tháp.

Nghi lễ có sự tham gia của các chức sắc và những người đảm nhiệm từng vai trò
theo truyền thống. Các nghi thức liên quan đến mở cửa đền, tháp, tẩy uế,
dâng lễ, mặc y trang cho tượng thờ và cầu cúng tạo nên phần thiêng của Katé.

Trình tự, tên gọi và cách tiến hành từng nghi thức có những đặc điểm riêng theo
từng nơi. Vì vậy, không nên gom tất cả thành một “quy trình Katé” duy nhất mà
bỏ qua truyền thống của từng đền, tháp.

Katé cũng không kết thúc khi phần lễ tại đền, tháp hoàn tất.

Không khí Katé tiếp tục trở về **palei** và từng **gia đình**. Người thân gặp
gỡ, gia đình sum họp, tưởng nhớ tổ tiên và duy trì những mối quan hệ cộng đồng.

Có thể hình dung không gian Katé chuyển dần qua ba lớp:

**Đền, tháp → Palei → Gia đình**

Chính sự chuyển tiếp ấy khiến Katé vừa có phần nghi lễ tôn giáo do chức sắc
đảm nhiệm, vừa có một không gian sinh hoạt cộng đồng rộng hơn.


## Ý nghĩa của Katé

Khó gói Katé vào một ý nghĩa duy nhất.

Ở tầng tín ngưỡng, Katé là dịp thực hiện nghi lễ đối với các vị thần, những vị
vua được thần hóa và các đối tượng được cộng đồng phụng thờ.

Ở palei và gia đình, Katé gắn với tưởng nhớ tổ tiên, gặp gỡ người thân và duy
trì mối quan hệ cộng đồng.

Trong đời sống nông nghiệp truyền thống, lễ tục còn gắn với những mong ước về
cuộc sống yên lành, mùa màng và sự thuận hòa giữa con người với thế giới xung
quanh.

Katé cũng là nơi nhiều yếu tố văn hóa Chăm tiếp tục hiện diện cùng nhau:
Chăm lịch, ngôn ngữ, âm nhạc, nhạc cụ, múa, trang phục, lễ vật, chức sắc,
đền tháp và những tri thức được truyền qua nhiều thế hệ.

Câu chuyện người Raglai gìn giữ y trang lại cho thấy Katé còn lưu giữ ký ức
về mối quan hệ giữa những cộng đồng đã cùng sinh sống lâu đời trên vùng đất
này.


## Katé có phải là “Tết Chăm”?

Katé đôi khi được truyền thông giới thiệu là **“Tết của người Chăm”** hoặc
“Tết Katê”.

Cách gọi này khá phổ biến và có thể giúp người ngoài cộng đồng dễ hình dung về
quy mô của dịp lễ, nhưng nếu dùng để xác định bản chất hay tên gọi của Katé
thì chưa thật chính xác.

Katé diễn ra vào **bilan 7**, không phải thời điểm bắt đầu năm Chăm lịch.

Một số nhà nghiên cứu văn hóa Chăm cũng đã lưu ý đến việc không nên đồng nhất
Katé với khái niệm “Tết”.

Vì vậy, Sakawi sử dụng tên gọi **“Lễ Katé”** hoặc **“Lễ hội Katé”**, thay vì
gọi đây là “Tết Chăm”.


## Katé có từ bao giờ?

Nguồn gốc và thời điểm hình thành Katé vẫn còn những cách giải thích khác nhau
trong giới nghiên cứu.

Nhà nghiên cứu **Sakaya (Trương Văn Món)** đặt sự xuất hiện của Katé vào
khoảng thế kỷ XV, trong quá trình biến đổi của văn hóa và tín ngưỡng Champa.

Trong khi đó, nhà nghiên cứu **Po Dharma** đưa ra cách lý giải khác, cho rằng
Katé xuất hiện muộn hơn, sau thời Po Rome.

Sự khác biệt này liên quan đến cách đọc các nguồn tư liệu lịch sử, bia ký,
sự biến đổi của hệ thống thần linh và quá trình hình thành việc phụng thờ các
vị vua được thần hóa.

Vì chưa có một kết luận được tất cả các nhà nghiên cứu thống nhất, sẽ thận
trọng hơn khi xem đây là **những giả thuyết nghiên cứu khác nhau về nguồn gốc
Katé**, thay vì khẳng định một niên đại duy nhất.


## Từ lễ tục đến lễ hội Katé ngày nay

Katé ngày nay vừa duy trì những nghi thức truyền thống, vừa có thêm nhiều hoạt
động văn hóa, nghệ thuật, giao lưu và giới thiệu di sản.

Tiếng trống Ginăng, kèn Saranai, những điệu múa và dòng người lên tháp đã trở
thành hình ảnh quen thuộc mỗi mùa Katé.

Nhưng Katé không chỉ nằm ở phần hội dễ nhìn thấy.

Phía sau đó còn có cách người Chăm xác định ngày lễ bằng chính lịch của mình;
hệ thống chức sắc và nghi lễ; các vị được phụng thờ; mối liên hệ giữa đền
tháp, palei và gia đình; sự đối ứng Katé–Ca-mbur; và cả câu chuyện Chăm–Raglai
vẫn được tiếp tục qua việc gìn giữ và trao nhận y trang Po Inâ Nâgar.

Nhìn từ những lớp ấy, Katé không chỉ là một sự kiện diễn ra mỗi năm.
Đó là một phần của đời sống văn hóa vẫn đang được cộng đồng tiếp tục thực hành
và trao truyền.


# Katé trên Sakawi

Sakawi ghi nhận hai mốc liên quan trực tiếp đến nội dung bài viết:

## Katé palei Hamu Tanran

Diễn ra **trước chính lễ một ngày**, gắn với lễ đón y trang Po Inâ Nâgar.

## Katé

Diễn ra vào **1 bingun bilan 7 Chăm lịch**, ngày chính lễ tại các đền, tháp.

Ngày Dương lịch tương ứng thay đổi theo từng năm và được Sakawi tính từ dữ liệu
Chăm lịch.

Nhờ vậy, khi thấy hai sự kiện nằm liền nhau trên lịch, người dùng có thể hiểu
đây không phải hai lễ Katé riêng biệt, mà là **hai mốc trong diễn tiến của cùng
một mùa lễ**.


# Tài liệu tham khảo

1. Sakaya (Trương Văn Món),
   "Lễ hội của người Chăm",
   NXB Văn hóa Dân tộc, 2003.

   Verified bibliographic URL:
   https://books.google.com/books/about/L%E1%BB%85_h%E1%BB%99i_c%E1%BB%A7a_ng%C6%B0%E1%BB%9Di_Ch%C4%83m.html?id=T-FuAAAAMAAJ

2. Sakaya (Trương Văn Món),
   "Sắc màu lễ hội Katé / The Colors of the Katé Festival".

   Do not invent a URL if none is already verified in the repository/task context.

3. Sakaya (Trương Văn Món),
   "Tiếp cận một số vấn đề văn hóa Champa",
   NXB Tri Thức, 2013.

4. Phan Quốc Anh,
   research concerning Katé, including:
   "Lễ hội Katê của người Chăm ở Ninh Thuận"
   and
   "Những đặc trưng của lễ hội Ka Tê".

5. Ngô Văn Doanh,
   "Lễ hội chuyển mùa của người Chăm",
   2006.

6. Viện Âm nhạc Việt Nam,
   materials on traditional music, dance and festivals of the Chăm Bàlamôn
   community in Ninh Thuận, especially material concerning the Po Inâ Nâgar
   y trang observance and Chăm–Raglai relationship.

   Verified URL:
   https://vienamnhac.vn/du-an/suu-tam-bao-ton-am-nhac-va-mua-dan-gian-trong-mot-so-le-hoi-truyen-thong-cua-nguoi-cham-balamon-tai-tinh-ninh-thuan

7. VOV,
   article concerning Katé including discussion with researcher
   Trương Văn Món and material about Chăm–Raglai and y trang.

   Verified URL:
   https://vov.vn/van-hoa-giai-tri/le-hoi-kate-ngay-hoi-van-hoa-lon-cua-nguoi-cham-283970.vov

8. Thế giới Di sản,
   supporting material concerning traditional Chăm festivals in Ninh Thuận
   and the Chăm–Raglai relationship.

   Verified URL:
   https://thegioidisan.vn/vi/le-hoi-dan-gian-dac-sac-cua-dan-toc-cham-o-ninh-thuan.html

# Ghi chú của Sakawi

**Sakawi mang tính tham khảo. Lịch chính thức và thời gian tổ chức các nghi lễ,
lễ hội thực tế thực hiện theo lịch do hội đồng chức sắc phát hành và thông báo
của cộng đồng địa phương.**`;
